import * as z from "zod";

export const DateFromDateOrIsoStringSchema = z
  .union([z.iso.datetime(), z.date()])
  .pipe(z.coerce.date())
  .meta({ annotation: "Date" });
